import { NgModule } from "@angular/core";
import { LoadingSharedModule, SpinnerSharedModule } from "pf_styleguide";
import { LoadingSpinnerComponent } from "./loading-spinner.component";
import { LoadingComponent } from "./loading.component";

@NgModule({
    declarations: [LoadingComponent, LoadingSpinnerComponent],
    exports: [LoadingComponent, LoadingSpinnerComponent],
    imports: [LoadingSharedModule, SpinnerSharedModule],
})
export class LoadingModule {}
